module.exports = __webpack_public_path__ + "static/media/cDAIcUSDC-logo.6640e9ec.png";